import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Container, Row, Col } from 'react-bootstrap';
import * as api from '~/Services/Service';
import HeaderAzul from '~/Components/HeaderAzul/HeaderAzul';
import Loading from '~/Components/Loading';
import FiltrosRelatorio from './FiltrosRelatorio';
import PainelGraficosPizza from './PainelGraficosPizza';
import GraficoPergunta from './GraficoPergunta';

const RelatorioPesquisaProspecto = function() {
  const [dados, setDados] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [opcoesEmpreendimentos, setOpcoesEmpreendimentos] = useState([]);
  const [dadosIniciais, setDadosIniciais] = useState(null);
  const [isLoadingIniciais, setIsLoadingIniciais] = useState(false);
  const [filtrosOrigem, setFiltrosOrigem] = useState({ origem: '', midia: '', campanha: '' });

  useEffect(function() {
    api.obterEmpreendimentosPesquisaProspecto()
      .then(function(emps) {
        setOpcoesEmpreendimentos(emps);
      })
      .catch(function() {
        toast.error('Erro ao carregar empreendimentos.');
      });
  }, []);

  const handleEmpreendimentoChange = function(codigoFamilia, dataInicial, dataFinal) {
    setDados(null);
    setDadosIniciais(null);
    setFiltrosOrigem({ origem: '', midia: '', campanha: '' });

    if (!codigoFamilia) return;

    setIsLoadingIniciais(true);
    api.obterDadosIniciaisPesquisaProspecto({
      codigo_familia: codigoFamilia,
      data_inicial: dataInicial || null,
      data_final: dataFinal || null,
    })
      .then(function(response) {
        setDadosIniciais(response);
      })
      .catch(function() {
        toast.error('Erro ao carregar dados do empreendimento.');
      })
      .finally(function() {
        setIsLoadingIniciais(false);
      });
  };

  const handleSubmit = function(values) {
    if (!values.codigo_familia) {
      toast.warn('Por favor selecione um empreendimento.');
      return;
    }
    if (!values.codigos_perguntas || values.codigos_perguntas.length === 0) {
      toast.warn('Selecione ao menos uma pergunta.');
      return;
    }

    setIsLoading(true);
    setDados(null);

    const filtros = {
      codigo_familia: values.codigo_familia,
      data_inicial: values.data_inicial || null,
      data_final: values.data_final || null,
      somente_compra: values.somente_compra || 'T',
      respostas_campanha: values.respostas_campanha === 'S',
      origem: filtrosOrigem.origem || null,
      midia: filtrosOrigem.midia || null,
      campanha: filtrosOrigem.campanha || null,
      codigos_perguntas: values.codigos_perguntas,
    };

    api.consultarRelatorioPesquisaProspecto(filtros)
      .then(function(response) {
        if (response.total_prospectos === 0) {
          toast.info('Nenhum prospecto encontrado, verifique os parametros informados.');
          return;
        }
        setDados(response);
      })
      .catch(function(err) {
        toast.error((err && err.message) || 'Erro ao consultar relatorio.');
      })
      .finally(function() {
        setIsLoading(false);
      });
  };

  return (
    <Container fluid className="px-3 py-3">
      <HeaderAzul title="Pesquisa Prospecto" />

      <FiltrosRelatorio
        onSubmit={handleSubmit}
        isLoading={isLoading}
        opcoesEmpreendimentos={opcoesEmpreendimentos}
        dadosIniciais={dadosIniciais}
        isLoadingIniciais={isLoadingIniciais}
        onEmpreendimentoChange={handleEmpreendimentoChange}
      />

      {isLoadingIniciais && <Loading label="Carregando dados do empreendimento" />}

      {dadosIniciais && dadosIniciais.dados_origem_midia_campanha && dadosIniciais.dados_origem_midia_campanha.length > 0 && (
        <PainelGraficosPizza
          dados={dadosIniciais.dados_origem_midia_campanha}
          totalCaptados={dadosIniciais.total_prospectos_captados}
          filtrosOrigem={filtrosOrigem}
          onFiltrosOrigemChange={setFiltrosOrigem}
        />
      )}

      {isLoading && <Loading label="Carregando relatorio" />}

      {dados && (
        <>
          <h5 className="mb-3">
            Total de Prospectos: <strong>{dados.total_prospectos}</strong>
          </h5>

          <Row>
            {dados.graficos && dados.graficos.map(function(grafico, index) {
              return (
                <Col xs={12} md={6} key={grafico.codigo_pergunta || index}>
                  <GraficoPergunta
                    titulo={grafico.descricao_pergunta}
                    respostas={grafico.respostas}
                    index={index}
                  />
                </Col>
              );
            })}
          </Row>
        </>
      )}
    </Container>
  );
};

export default RelatorioPesquisaProspecto;
